function i() {
  let e, r;
  return {
    promise: new Promise((o, s) => {
      e = o, r = s;
    }),
    // @ts-expect-error skip "variable is used before being assigned" error
    resolve: e,
    // @ts-expect-error skip "variable is used before being assigned" error
    reject: r
  };
}
export {
  i as w
};
//# sourceMappingURL=withResolvers.js.map
